<div class="flex flex-col justify-between gap-4 h-full bg-white">
	<div class="flex flex-col gap-2 p-4">
		<p class="mb-4 text-sm text-gray-500">
			Clients and associated contacts on matter when an intake request is
			initiated are automatically added to your form.
		</p>

		<label for="add-contact-dropdown" class="text-sm text-gray-700"
			>Add New or Existing Contact</label
		>
		<app-dropdown
			[id]="'add-contact-dropdown'"
			placeholder="Search to add contact "
			[itemGroups]="[{ items: viewModel_().clientDropdownItems }]"
			(onSelect)="addClientEditAccess($event)"
			emptyStateMessage="No additional clients on matter"
		></app-dropdown>
		@for (invitee of viewModel_().sortedInvitees; track invitee.clientId) {
			<app-intake-client-pill
				[invitee_]="invitee"
				[portalInvite_]="viewModel_().portalInvite"
			/>
		}
	</div>
	<div class="flex justify-end">
		<ui-button label="Share" (click)="sendIntakeEmail()"></ui-button>
	</div>
</div>
